import type { ReactNode } from 'react';
import { InfoIcon } from '@phosphor-icons/react';
import './checkout_motive_section.css';

export interface CheckoutMotiveSectionProps {
  /** "Motivo da viagem". */
  title: string;
  /** Aviso de viagem fora da política; ausente ⇒ dentro. */
  outOfPolicyHint?: string;
  /** Quem dá a política da reserva, quando há mais de um viajante. */
  policyOwner?: { label: string; name: string };
  /** Os campos da reserva (motivo, justificativa, observação), coletados uma vez. */
  children: ReactNode;
}

/** O cartão do motivo da viagem: os dados da reserva coletados UMA vez, abaixo dos
 *  cartões dos viajantes. */
export function CheckoutMotiveSection({
  title,
  outOfPolicyHint,
  policyOwner,
  children,
}: Readonly<CheckoutMotiveSectionProps>) {
  return (
    <div className="cpa">
      <div className="cpa-header">
        <h3 className="cpa-title">{title}</h3>
      </div>
      {outOfPolicyHint && (
        <p className="cpa-policy-hint">
          <InfoIcon size={14} aria-hidden />
          <span>{outOfPolicyHint}</span>
        </p>
      )}
      {policyOwner && (
        <div className="pcm-policy">
          <span className="pcm-policy-label">{policyOwner.label}</span>
          <strong className="pcm-policy-value">{policyOwner.name}</strong>
        </div>
      )}
      {children}
    </div>
  );
}
